export const API_BASE_URL = "https://your-api-url.com/";

export const WEB_SOCKET_URL =
  "http://start2finish-lb-qa-1956344113.ca-central-1.elb.amazonaws.com";
